import React, { useContext } from 'react';
import { withTheme } from 'styled-components';

import { Context } from '@store/store';

import { StyledButtons } from './zoom-buttons.styles';

import Button from './zoom-button';

const ZoomButtons = ({ theme }) => {
  const [state, dispatch] = useContext(Context);

  return (
    <StyledButtons>
      <Button
        onClick={() => dispatch({ type: 'ZOOM_IN_OUT', payload: 0.2 })}
        title="Увеличить масштаб страниц(ы)"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
          <path d="M13.5 8.5H8.5V13.5C8.5 13.7652 8.39464 14.0196 8.20711 14.2071C8.01957 14.3946 7.76522 14.5 7.5 14.5C7.23478 14.5 6.98043 14.3946 6.79289 14.2071C6.60536 14.0196 6.5 13.7652 6.5 13.5V8.5H1.5C1.23478 8.5 0.98043 8.39464 0.792893 8.20711C0.605357 8.01957 0.5 7.76522 0.5 7.5C0.5 7.23478 0.605357 6.98043 0.792893 6.79289C0.98043 6.60536 1.23478 6.5 1.5 6.5H6.5V1.5C6.5 1.23478 6.60536 0.980429 6.79289 0.792893C6.98043 0.605357 7.23478 0.5 7.5 0.5C7.76522 0.5 8.01957 0.605357 8.20711 0.792893C8.39464 0.980429 8.5 1.23478 8.5 1.5V6.5H13.5C13.7652 6.5 14.0196 6.60536 14.2071 6.79289C14.3946 6.98043 14.5 7.23478 14.5 7.5C14.5 7.76522 14.3946 8.01957 14.2071 8.20711C14.0196 8.39464 13.7652 8.5 13.5 8.5Z" fill="#8F8F8F"/>
        </svg>
      </Button>
      <Button
        onClick={() => dispatch({ type: 'ZOOM_IN_OUT', payload: -0.2 })}
        title="Уменьшить масштаб страниц(ы)"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="3" viewBox="0 0 17 3" fill="none">
          <path d="M17 1.5C17 1.76522 16.8925 2.01957 16.7012 2.20711C16.51 2.39464 16.2505 2.5 15.98 2.5H1.02C0.749479 2.5 0.490038 2.39464 0.298751 2.20711C0.107464 2.01957 0 1.76522 0 1.5C0 1.23478 0.107464 0.980429 0.298751 0.792893C0.490038 0.605357 0.749479 0.5 1.02 0.5H15.98C16.2505 0.5 16.51 0.605357 16.7012 0.792893C16.8925 0.980429 17 1.23478 17 1.5Z" fill="#8F8F8F"/>
        </svg>
      </Button>
      <Button
        onClick={() => dispatch({ type: 'ROTATE_PAGE', payload: 90 })}
        title="Повернуть страницу на 90 градусов"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
          <path d="M13.5 6.65521C13.3095 5.08769 12.596 3.64878 11.493 2.60785C10.39 1.56691 8.97307 0.995302 7.50754 1.00003C6.04201 1.00476 4.62832 1.58549 3.53109 2.63353C2.43386 3.68156 1.72832 5.12505 1.54654 6.69377C1.36477 8.26249 1.71921 9.84891 2.54353 11.1561C3.36785 12.4632 4.60554 13.4014 6.02489 13.7952C7.44425 14.1889 8.94798 14.0111 10.2546 13.2951C11.5612 12.5791 12.5811 11.3739 13.1234 9.90521M13.5 13.9677V9.90521H9.73403" stroke="#8F8F8F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </Button>
    </StyledButtons>
  );
};

export default withTheme(ZoomButtons);
